export default "__VITE_ASSET__fe92c3cd__"